module.exports = __webpack_public_path__ + "ad527cc5ec23d6da66e8a1d6772ea6d3.woff";